import React from "react";
import { Link } from "react-router-dom";
import { airportPath } from "../../../data/serviceAreas";
// @ts-ignore
import "./RoutesSection.css";

const AIRPORT_NAMES: Record<string, string> = {
  PHL: "Philadelphia International",
  EWR: "Newark Liberty International",
  JFK: "JFK International",
  ACY: "Atlantic City International",
};

interface Route {
  city: string;
  state: "NJ" | "PA";
  slug: string;
  airport: "PHL" | "EWR" | "JFK" | "ACY";
  time: string;
}

const routes: Route[] = [
  { city: "Glassboro", state: "NJ", slug: "glassboro-nj", airport: "PHL", time: "About 30–40 min" },
  { city: "Cherry Hill", state: "NJ", slug: "cherry-hill-nj", airport: "PHL", time: "About 20–30 min" },
  { city: "Voorhees", state: "NJ", slug: "voorhees-nj", airport: "PHL", time: "About 25–35 min" },
  { city: "Sewell", state: "NJ", slug: "sewell-washington-township-nj", airport: "PHL", time: "About 30–40 min" },
  { city: "Williamstown", state: "NJ", slug: "williamstown-nj", airport: "ACY", time: "About 40–50 min" },
  { city: "Deptford", state: "NJ", slug: "deptford-nj", airport: "EWR", time: "About 45–60 min" },
  { city: "Philadelphia", state: "PA", slug: "philadelphia-pa", airport: "JFK", time: "About 90–120 min" },
  { city: "Vineland", state: "NJ", slug: "vineland-nj", airport: "ACY", time: "About 30–40 min" },
];

export default function RoutesSection(): JSX.Element {
  return (
    <section className="routes-section py-5" id="popular-routes">
      <div className="container">
        <div className="text-center mb-5 gs-anim">
          <span className="section-badge">Popular Routes</span>
          <h2 className="section-title">Popular Airport Routes from South Jersey</h2>
          <p className="section-sub">
            Frequent pickups across South Jersey and Philadelphia. Don&apos;t see
            your route? Request a quote for any pickup or drop-off in NJ, PA, or
            NY &mdash; fares are confirmed before you book.
          </p>
        </div>

        <div className="row g-3">
          {routes.map((route) => (
            <div className="col-12 col-md-6 gs-anim" key={`${route.slug}-${route.airport}`}>
              <div className="route-card">
                <div className="route-main">
                  <Link
                    to={`/limo-service/${route.slug}`}
                    className="route-place"
                    title={`Limo service in ${route.city}, ${route.state}`}
                  >
                    {route.city}, {route.state}
                  </Link>
                  <span className="route-arrow" aria-hidden="true">
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </span>
                  <Link
                    to={airportPath(route.airport)}
                    className="route-airport"
                    title={`${AIRPORT_NAMES[route.airport]} (${route.airport}) car service`}
                  >
                    {route.airport}
                  </Link>
                </div>
                <p className="route-meta">
                  {AIRPORT_NAMES[route.airport]} &middot; {route.time}
                </p>
                <Link
                  to="/get-a-quote"
                  state={{
                    tripType: "Airport",
                    pickup: `${route.city}, ${route.state}`,
                    dropoff: `${AIRPORT_NAMES[route.airport]} (${route.airport})`,
                  }}
                  className="route-quote"
                  title={`Get a quote for ${route.city} to ${route.airport}`}
                >
                  Get a quote <i className="fas fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 gs-anim">
          <Link
            to="/service-areas"
            className="btn gs-btn-outline-gold"
            title="All GS Limo Elite service areas"
          >
            <i className="fas fa-map-marked-alt me-2"></i>View All Service Areas
          </Link>
        </div>
      </div>
    </section>
  );
}
